"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Schema for DTO
 * Schema for DTO
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmployeelocationsApi = void 0;
const runtime = require("../runtime");
const index_1 = require("../models/index");
/**
 *
 */
class EmployeelocationsApi extends runtime.BaseAPI {
    /**
     * Follow one or more employees to track their locations
     * Follow Employees
     */
    followEmployeesRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['apiEmployeeLocationFollowsRequest'] == null) {
                throw new runtime.RequiredError('apiEmployeeLocationFollowsRequest', 'Required parameter "apiEmployeeLocationFollowsRequest" was null or undefined when calling followEmployees().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("BearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/employee-locations/follows`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.ApiEmployeeLocationFollowsRequestToJSON)(requestParameters['apiEmployeeLocationFollowsRequest']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ApiEmployeeLocationFollowsResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Follow one or more employees to track their locations
     * Follow Employees
     */
    followEmployees(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.followEmployeesRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Unfollow all employees that the user is currently following
     * Unfollow All Employees
     */
    unfollowAllEmployeesRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("BearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/employee-locations/follows`,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ApiEmployeeLocationUnfollowAllResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Unfollow all employees that the user is currently following
     * Unfollow All Employees
     */
    unfollowAllEmployees(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.unfollowAllEmployeesRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Unfollow a specific employee by their employee ID
     * Unfollow Employee
     */
    unfollowEmployeeRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['employeeId'] == null) {
                throw new runtime.RequiredError('employeeId', 'Required parameter "employeeId" was null or undefined when calling unfollowEmployee().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("BearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/employee-locations/follows/{employeeId}`.replace(`{${"employeeId"}}`, encodeURIComponent(String(requestParameters['employeeId']))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ApiEmployeeLocationUnfollowResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Unfollow a specific employee by their employee ID
     * Unfollow Employee
     */
    unfollowEmployee(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.unfollowEmployeeRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
exports.EmployeelocationsApi = EmployeelocationsApi;
